import Fetch from "@/assets/js/Fetch";
import store from "@/store/auth";
import Auth from "@/store/auth";

class Results {
  getByitem(itemId, startPosition = 0) {
    return new Promise(resolve => {
      let url =
        process.env.VUE_APP_API +
        "items/" +
        itemId +
        "/results/?start=" +
        startPosition;
      Fetch.run(url).then(result => {
        resolve(result);
      });
    });
  }

  addByDate(itemId, resultDate, price) {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "items/" + itemId + "/results/";
      fetch(url, {
        method: "PUT",
        body: JSON.stringify({
          date: resultDate,
          price: price
        }),
        headers: {
          Authorization: "Bearer " + store.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json.updated);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
          resolve(false);
        }
      });
    });
  }
}

export default new Results();
